import { LeadStatusDto } from '@sr/dto';
import { leadBaseApi } from 'entities/lead/api';
import { LEAD_BASE_URL } from 'shared/api/api';
import { salaryApi } from 'entities/salary/salary.api';

const injectedApi = leadBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateLeadStatus: builder.mutation<LeadStatusDto, { leadId: number; statusId: number }>({
      query: ({ leadId, statusId }) => ({
        url: `${LEAD_BASE_URL}/${leadId}/status`,
        body: { statusId },
        method: 'PUT',
      }),
      async onQueryStarted({ leadId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(salaryApi.util.invalidateTags(['workShifts']));
        } catch (error) {
          console.error('Failed to invalidate lead audit after status update', error);
        }
      },
    }),
  }),
});

export const leadStatusApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['lead'],
  endpoints: {
    updateLeadStatus: {
      invalidatesTags: ['lead', 'lead-list'],
    },
  },
});
